import * as TypeGraphQL from "type-graphql";
export var DeadLetterMessageScalarFieldEnum;
(function (DeadLetterMessageScalarFieldEnum) {
    DeadLetterMessageScalarFieldEnum["id"] = "id";
    DeadLetterMessageScalarFieldEnum["timestamp"] = "timestamp";
    DeadLetterMessageScalarFieldEnum["accountId"] = "accountId";
    DeadLetterMessageScalarFieldEnum["ticker"] = "ticker";
    DeadLetterMessageScalarFieldEnum["action"] = "action";
    DeadLetterMessageScalarFieldEnum["quantity"] = "quantity";
    DeadLetterMessageScalarFieldEnum["strikePrice"] = "strikePrice";
    DeadLetterMessageScalarFieldEnum["expirationDate"] = "expirationDate";
    DeadLetterMessageScalarFieldEnum["optionType"] = "optionType";
    DeadLetterMessageScalarFieldEnum["strategy"] = "strategy";
    DeadLetterMessageScalarFieldEnum["orderType"] = "orderType";
    DeadLetterMessageScalarFieldEnum["limitPrice"] = "limitPrice";
    DeadLetterMessageScalarFieldEnum["errorMessage"] = "errorMessage";
    DeadLetterMessageScalarFieldEnum["errorCode"] = "errorCode";
    DeadLetterMessageScalarFieldEnum["errorStack"] = "errorStack";
    DeadLetterMessageScalarFieldEnum["retryCount"] = "retryCount";
    DeadLetterMessageScalarFieldEnum["maxRetries"] = "maxRetries";
    DeadLetterMessageScalarFieldEnum["lastRetryAt"] = "lastRetryAt";
    DeadLetterMessageScalarFieldEnum["nextRetryAt"] = "nextRetryAt";
    DeadLetterMessageScalarFieldEnum["backoffMs"] = "backoffMs";
    DeadLetterMessageScalarFieldEnum["status"] = "status";
    DeadLetterMessageScalarFieldEnum["resolvedAt"] = "resolvedAt";
    DeadLetterMessageScalarFieldEnum["resolvedBy"] = "resolvedBy";
    DeadLetterMessageScalarFieldEnum["resolution"] = "resolution";
    DeadLetterMessageScalarFieldEnum["tradeContext"] = "tradeContext";
    DeadLetterMessageScalarFieldEnum["accountState"] = "accountState";
    DeadLetterMessageScalarFieldEnum["marketContext"] = "marketContext";
    DeadLetterMessageScalarFieldEnum["validationErrors"] = "validationErrors";
    DeadLetterMessageScalarFieldEnum["failureCategory"] = "failureCategory";
    DeadLetterMessageScalarFieldEnum["severity"] = "severity";
    DeadLetterMessageScalarFieldEnum["tags"] = "tags";
    DeadLetterMessageScalarFieldEnum["createdBy"] = "createdBy";
    DeadLetterMessageScalarFieldEnum["updatedAt"] = "updatedAt";
    DeadLetterMessageScalarFieldEnum["notes"] = "notes";
})(DeadLetterMessageScalarFieldEnum || (DeadLetterMessageScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(DeadLetterMessageScalarFieldEnum, {
    name: "DeadLetterMessageScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=DeadLetterMessageScalarFieldEnum.js.map